/* eslint-disable */
// Generated by scripts/extract-tinkercad-manifest.js
export const TINKERCAD_COURSE = {
  "id": "tinkercad-3d",
  "name": "3D-модели в Tinkercad",
  "description": "Страницы уроков в формате лендинга: режим ученика и педагога, шаги, чек-листы, мини-тесты и Rocket Coins.",
  "lessons": [
    {
      "id": "1",
      "file": "lesson_01.html",
      "thumb": "/tinkercad-lessons/thumbs/lesson_01.jpg",
      "title": "Привет, 3D!",
      "description": "Познакомься с Tinkercad, освой управление камерой и собери первую 3D-модель — кота из простых фигур."
    },
    {
      "id": "2",
      "file": "lesson_02.html",
      "thumb": "/tinkercad-lessons/thumbs/lesson_02.jpg",
      "title": "Тайная жизнь",
      "description": "Построй секретную базу для своего 3D-питомца: пол, стены и мебель. По пути освоишь группировку объектов, секрет клавиши Shift и свои цвета."
    },
    {
      "id": "3",
      "file": "lesson_03.html",
      "thumb": "/tinkercad-lessons/thumbs/lesson_03.jpg",
      "title": "Время технологий!",
      "description": "Снаряди своего спецагента гаджетами: узнай, что такое референс и стиль Low Poly, и смоделируй рацию из простых фигур."
    },
    {
      "id": "4",
      "file": "lesson_04.html",
      "thumb": "/tinkercad-lessons/thumbs/lesson_04.jpg",
      "title": "Рисуй, раскрашивай, собирай!",
      "description": "Освой инструмент Scribble: превращай рисунок в объёмную фигуру и собери аппетитный бургер, а затем пиццу."
    },
    {
      "id": "5",
      "file": "lesson_05.html",
      "thumb": "/tinkercad-lessons/thumbs/lesson_05.jpg",
      "title": "Собери космонавта",
      "description": "Начинаем космическое путешествие: слепим Луну и соберём по референсу главного героя модуля — космонавта. По пути освоишь точные размеры фигур и инструмент «Выровнять»."
    },
    {
      "id": "6",
      "file": "lesson_06.html",
      "thumb": "/tinkercad-lessons/thumbs/lesson_06.jpg",
      "title": "Держим курс на Луну!",
      "description": "Освой инструмент «Отверстие»: вырезай одну фигуру из другой. Сделай кратеры на Луне, собери ракету с иллюминаторами и поставь рядом с космонавтом флаг."
    },
    {
      "id": "7",
      "file": "lesson_07.html",
      "thumb": "/tinkercad-lessons/thumbs/lesson_07.jpg",
      "title": "Приготовь скафандр!",
      "description": "Научись делать стекло в Tinkercad: прозрачный шлем для космонавта, лицо под стеклом и друг-пришелец в НЛО с прозрачным куполом."
    },
    {
      "id": "8",
      "file": "lesson_08.html",
      "thumb": "/tinkercad-lessons/thumbs/lesson_08.jpg",
      "title": "Последний штрих!",
      "description": "Заканчиваем проект модуля: надень космонавту перчатки с помощью инструмента «Отразить зеркально», расскажи о своей работе и проверь знания в викторине."
    },
    {
      "id": "9",
      "file": "lesson_09.html",
      "thumb": "/tinkercad-lessons/thumbs/lesson_09.jpg",
      "title": "Мой дом — моя крепость",
      "description": "Начинаем игровую локацию: размечаем участок с дорогой и строим дом — стены, окна со стёклами, крыша с черепицей, дверь, крыльцо и забор. Освоишь настройку рабочей области и вспомогательную плоскость."
    },
    {
      "id": "10",
      "file": "lesson_10.html",
      "thumb": "/tinkercad-lessons/thumbs/lesson_10.jpg",
      "title": "Машина мечты",
      "description": "Собери спортивную машину для своей локации: кузов из скруглённых форм, стёкла, арки колёс, зеркала и фары. Научишься делать сложные формы «Отверстием», работать в ортогональном виде и брать колёса из библиотеки готовых форм."
    },
    {
      "id": "11",
      "file": "lesson_11.html",
      "thumb": "/tinkercad-lessons/thumbs/lesson_11.jpg",
      "title": "Вверх! Воздушный шар",
      "description": "Подними в небо над своей локацией воздушный шар: купол из шара и параболоида, корзина из пирамиды, стропы, горелка и табличка с названием. Освоишь инструмент «Текст»."
    },
    {
      "id": "12",
      "file": "lesson_12.html",
      "thumb": "/tinkercad-lessons/thumbs/lesson_12.jpg",
      "title": "Сам себе дизайнер",
      "description": "Добавь последние штрихи в локацию: деревья и клумбы, скамейки, фонари и магазин, готовые модели людей и предметов из библиотеки. Сегодня ты сам решаешь, как будет выглядеть твой мир."
    },
    {
      "id": "13",
      "file": "lesson_13.html",
      "thumb": "/tinkercad-lessons/thumbs/lesson_13.jpg",
      "title": "Создаём знаменитых птиц Angry Birds",
      "description": "Смоделируй Рэда — лидера птиц из Angry Birds — и рогатку, чтобы запустить его в бой. Потренируешься задавать точные размеры, выравнивать фигуры и обрезать их кубом-отверстием."
    },
    {
      "id": "14",
      "file": "lesson_14.html",
      "thumb": "/tinkercad-lessons/thumbs/lesson_14.jpg",
      "title": "Моделируем милых миньонов",
      "description": "Собери миньона из мультфильма «Гадкий я»: тело из сфер и цилиндра, комбинезон сложной формы, очки, улыбку с зубами, ботинки и руки. Освоишь вычитание форм отверстиями и точное выравнивание."
    },
    {
      "id": "15",
      "file": "lesson_15.html",
      "thumb": "/tinkercad-lessons/thumbs/lesson_15.jpg",
      "title": "Создаём персонажей Minecraft",
      "description": "Испытание: смоделируй Стива из Minecraft, используя только одну фигуру — куб. Познакомишься с пиксель-артом, поработаешь в плоском виде и сам сделаешь предмет инвентаря."
    },
    {
      "id": "16",
      "file": "lesson_16.html",
      "thumb": "/tinkercad-lessons/thumbs/lesson_16.jpg",
      "title": "Тренировка окончена!",
      "description": "Сегодня ты сам выбираешь героя: найди референс, разбери его на простые формы и смоделируй персонажа, используя всё, чему научился в Модуле 5."
    },
    {
      "id": "17",
      "file": "lesson_17.html",
      "thumb": "/tinkercad-lessons/thumbs/lesson_17.jpg",
      "title": "Волшебники существуют!",
      "description": "Собери волшебника в плаще с капюшоном и остроконечным колпаком, а потом научись «телепортировать» картинки из интернета прямо в Tinkercad."
    },
    {
      "id": "18",
      "file": "lesson_18.html",
      "thumb": "/tinkercad-lessons/thumbs/lesson_18.jpg",
      "title": "Где мой волшебный посох?",
      "description": "Дай волшебнику из прошлого урока посох, открытую книгу заклинаний и котёл с кипящим зельем — а потом добавь свой магический декор."
    },
    {
      "id": "19",
      "file": "lesson_19.html",
      "thumb": "/tinkercad-lessons/thumbs/lesson_19.jpg",
      "title": "Больше 3D-моделей!",
      "description": "Собери логотип Brawl Stars — жёлтый череп на чёрном круге и шестиконечной звезде. Отработаешь создание сложных форм из простых: срезы отверстиями, выравнивание, отражение и параметры звезды."
    },
    {
      "id": "20",
      "file": "lesson_20.html",
      "thumb": "/tinkercad-lessons/thumbs/lesson_20.jpg",
      "title": "Выставка персонажей!",
      "description": "Собери все свои модели в один проект-портфолио: научись переносить объекты между проектами, подписывать их табличками и делиться ссылкой на выставку."
    },
    {
      "id": "21",
      "file": "lesson_21.html",
      "thumb": "/tinkercad-lessons/thumbs/lesson_21.jpg",
      "title": "Возводим горы, заливаем реки!",
      "description": "Создай свою первую игровую локацию: снежный ландшафт из полусфер, река в вырезанном русле и настоящий лёд из нового режима SimLab."
    },
    {
      "id": "22",
      "file": "lesson_22.html",
      "thumb": "/tinkercad-lessons/thumbs/lesson_22.jpg",
      "title": "Я есть Грут!",
      "description": "Сегодня ты скульптор: вылепи крону и ствол дерева в SculptGL, перенеси их в Tinkercad и вырасти на своей локации лес."
    },
    {
      "id": "23",
      "file": "lesson_23.html",
      "thumb": "/tinkercad-lessons/thumbs/lesson_23.jpg",
      "title": "Ожидается переменная облачность!",
      "description": "Создай погоду на своей локации: солнце, облака и цвет неба, а потом наполни мир травой, кустами и мелкими деталями — чтобы он перестал быть пустым."
    },
    {
      "id": "24",
      "file": "lesson_24.html",
      "thumb": "/tinkercad-lessons/thumbs/lesson_24.jpg",
      "title": "Открываем зоопарк",
      "description": "ZOO SAFARI: в этом зоопарке нет клеток. Подбери животных, которые смогут жить в твоей локации, разбери референс на простые формы и смоделируй минимум двух жителей."
    },
    {
      "id": "25",
      "file": "lesson_25.html",
      "thumb": "/tinkercad-lessons/thumbs/lesson_25.jpg",
      "title": "Это НЛО?",
      "description": "Открой новую сторону Tinkercad — визуальное программирование. Разберись в интерфейсе CodeBlocks, изучи готовую программу ракеты и напиши свой первый код: шар, который летает по сцене."
    },
    {
      "id": "26",
      "file": "lesson_26.html",
      "thumb": "/tinkercad-lessons/thumbs/lesson_26.jpg",
      "title": "Неограниченные возможности",
      "description": "Узнай, что такое условия, циклы и переменные, разбери готовые программы «Set color» и «Brick» и собери собственную анимацию: завиток из двадцати труб, который строит цикл."
    },
    {
      "id": "27",
      "file": "lesson_27.html",
      "thumb": "/tinkercad-lessons/thumbs/lesson_27.jpg",
      "title": "«Among Us» — анимация",
      "description": "Собери персонажа Among Us целиком из кода: нога, тело, лицо и рюкзак как отдельные объекты и их копии. А потом установи Kodu Game Lab — новый сервис, в котором мы будем делать игру."
    },
    {
      "id": "28",
      "file": "lesson_28.html",
      "thumb": "/tinkercad-lessons/thumbs/lesson_28.jpg",
      "title": "Время поиграть!",
      "description": "Сделай первую игру в Kodu Game Lab: ровер, которым ты управляешь с клавиатуры, боты, которые его преследуют и стреляют, и шкала жизней. Всё — на правилах «Когда → Делать»."
    },
    {
      "id": "29",
      "file": "lesson_29.html",
      "thumb": "/tinkercad-lessons/thumbs/lesson_29.jpg",
      "title": "Старт работы над итоговым проектом",
      "description": "Начинаем итоговый проект курса — собственный LEGO-мир. Сегодня соберём минифигурку по точным размерам: ноги, тело, руки и голову."
    },
    {
      "id": "30",
      "file": "lesson_30.html",
      "thumb": "/tinkercad-lessons/thumbs/lesson_30.jpg",
      "title": "Все решают детали!",
      "description": "Кастомизируй своего LEGO-персонажа: придумай образ, собери костюм и аксессуары, добавь спутника и начни локацию. Сегодня ты работаешь сам — как настоящий 3D-модельер."
    },
    {
      "id": "31",
      "file": "lesson_31.html",
      "thumb": "/tinkercad-lessons/thumbs/lesson_31.jpg",
      "title": "Скоро финишная черта!",
      "description": "Заверши итоговый проект: построй для персонажа площадку в духе LEGO City и потренируйся защищать проект — на следующем занятии выставка."
    },
    {
      "id": "32",
      "file": "lesson_32.html",
      "thumb": "/tinkercad-lessons/thumbs/lesson_32.jpg",
      "title": "Я — 3D‑модельер!",
      "description": "Выпускной: презентуй свой итоговый проект, посмотри работы одногруппников, вспомни весь пройденный путь — и узнай, куда двигаться дальше."
    }
  ]
};

export const TINKERCAD_LESSONS = TINKERCAD_COURSE.lessons;

export function getTinkercadLessonById(id) {
  return TINKERCAD_LESSONS.find(lesson => lesson.id === String(id));
}

export function getTinkercadLessonCourses() {
  return TINKERCAD_LESSONS.map((lesson, index) => ({
    _id: `tinkercad-lesson-${lesson.id}`,
    type: 'tinkercad',
    name: lesson.title,
    description: lesson.description,
    image: lesson.thumb,
    tier: 1,
    visible: true,
    isAvailable: true,
    langs: ['ru', 'en'],
    priority: index + 1,
    lessonId: lesson.id,
    lessonFile: lesson.file,
  }));
}
